var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 2.83398H5.99996C5.64634 2.83398 5.3072 2.97446 5.05715 3.22451C4.8071 3.47456 4.66663 3.8137 4.66663 4.16732V14.834C4.66663 15.1876 4.8071 15.5267 5.05715 15.7768C5.3072 16.0268 5.64634 16.1673 5.99996 16.1673H14C14.3536 16.1673 14.6927 16.0268 14.9428 15.7768C15.1928 15.5267 15.3333 15.1876 15.3333 14.834V6.83398L11.3333 2.83398Z",
    stroke: "#33894E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 2.83398V6.83398H15.3334",
    stroke: "#33894E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 10.166H7.33337",
    stroke: "#33894E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 12.834H7.33337",
    stroke: "#33894E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66671 7.5H8.00004H7.33337",
    stroke: "#33894E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/Documents.d542cae1c1d62bc54c5726f164d2a31b.svg";
export { ForwardRef as ReactComponent };